import { Component } from '@angular/core';
import { AssetApiService } from 'src/app/api/asset/assetApiService';
import { AssetsImportResponse } from 'src/app/api/asset/assetsImportResponse';
import { mapImportErrors } from 'src/app/utils/error-utils';

@Component({
    selector: 'import-assets',
    templateUrl: './import-assets.component.html',
    styleUrls: ['./import-assets.component.css'],
    standalone: false
})
export class ImportAssetsComponent {
  validationInProgress: boolean = false;
  uploadInProgress: boolean = false;
  errors: string[] = [];
  uploadResponse: AssetsImportResponse | null = null; //server response - for debugging
  canUpload: boolean = false;
  formData: FormData | null = null;
  uploadFinished: boolean = false;
  fileName: string = '';

  constructor(
    private assetsApiService: AssetApiService
  ) { }

  fileInputChange(fileInputEvent: any) {
    this.validationInProgress = true;
    this.canUpload = false;
    this.errors = [];
    this.uploadResponse = null;
    this.uploadFinished = false;
    this.fileName = fileInputEvent.target.files[0].name;

    this.formData = new FormData();
    this.formData.append('file', fileInputEvent.target.files[0]);
    this.formData.append('shouldValidateOnly', 'true');

    this.assetsApiService.importAssets(this.formData)
      .subscribe({
          next: response => {
            this.validationInProgress = false;
            this.errors = [];
            this.uploadResponse = response;
            this.canUpload = true;
          },
          error: error => {
            this.validationInProgress = false;
            this.errors = mapImportErrors(error.error.Message, error.error.Errors);
            this.canUpload = false;
            this.uploadResponse = error;
          }
        });
  }

  executeUpload() {
    if(this.formData == null) {
      console.error('No file selected');
      return;
    }

    this.formData.delete('shouldValidateOnly');
    this.formData.append('shouldValidateOnly', 'false');
    this.uploadInProgress = true;

    this.assetsApiService.importAssets(this.formData)
    .subscribe({
        next: response => {
          this.uploadInProgress = false;
          this.uploadResponse = response;
          this.uploadFinished = true;
          this.canUpload = false;
        },
        error: error => {
          console.log(error);
          this.uploadInProgress = false;
          this.errors = mapImportErrors(error.error.Message, error.error.Errors);
          this.uploadResponse = error;
        }
      });
  }
}
